import React, { useState } from 'react';
import { AsideFooter } from '../../../../components/layouts/Aside/Aside';
import UserTemplate from '../../User/User.template';
import Nav, { NavItem } from '../../../../components/layouts/Navigation/Nav';
import { appPages } from '../../../../config/pages.config';
import Modal, { ModalBody, ModalFooter } from '../../../../components/ui/Modal';
import Button from '../../../../components/ui/Button';
import AddPatientPage from '../../../../pages/AddPatient.page';
import { useAuth } from '../../../../context/authContext';
import { toast } from 'react-toastify';

const AsideFooterPart = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const {planData}=useAuth();
    const plan=planData?.isPlanActive;
    const handleOpenModal = () => setIsModalOpen(true);
    const handleCloseModal = () => setIsModalOpen(false);
    const addPatientPage={
		id: 'addPatientPage',
		to: '',
		text: 'Add Patient',
		icon: 'HeroUserPlus',   
      
	};
    return (
        <>
            <AsideFooter>
                <Nav>
                    <NavItem {...addPatientPage}  onClick={() => {
                    if (planData?.isPlanActive) { // Check the plan here
                        handleOpenModal();
                    }else{
                      toast.error("Please subscribe to a plan to continue");  
                    } }} />
                </Nav>
                <UserTemplate />
            </AsideFooter>



            {/* Modal for Add Patient Form */}
            <Modal isOpen={isModalOpen} setIsOpen={setIsModalOpen} isCentered size="sm">
                <ModalBody>
                    
                    <AddPatientPage setIsOpen={setIsModalOpen}  />
                </ModalBody>
                <ModalFooter className='justify-center'>
                    <Button onClick={handleCloseModal}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default AsideFooterPart;
